import React from "react";
import {
  AdminMainText,
  AdminHeaderAction,
  AdminFormSecondaryAction,
} from "../../AdminDashboard/shared/adminUx";

const PaymentComp = ({ method, image, status }) => {
  return (
    <>
     
        <div className="flex flex-col items-center justify-center">
          <div className="flex items-center justify-center">
            <img
              className="w-[50px] h-[50px]"
              src={image}
              alt="badge"
            />
          </div>
          <div className="mt-1">
            <AdminMainText className="text-offblack">{method}</AdminMainText>
          </div>
          <div className="mt-3">
            {status === "Remove" ? (
              <AdminFormSecondaryAction type="button">{status}</AdminFormSecondaryAction>
            ) : (
              <AdminHeaderAction type="button">{status}</AdminHeaderAction>
            )}
          </div>
        </div>
      
    </>
  );
};
export default PaymentComp;
